// Cookie storage adapter para Supabase Auth.
// Sustituye el localStorage default por cookies con domain=.vlscr.net,
// para que la sesión se comparta entre hub y subdominios (visitas, comisiones, rw,
// bitacora, alineaciones…).
//
// IMPORTANTE: el browser rechaza cookies con atributo `domain` si el hostname
// actual no es ese dominio (o un subdominio). Por eso solo aplicamos
// `domain=.vlscr.net` cuando estamos en vlscr.net o un subdominio. En otros
// hostnames (pages.dev preview, localhost dev) caemos a cookie sin domain
// (la sesión vive solo en ese hostname, sin SSO — aceptable para dev/preview).

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isVlscrDomain = hostname === 'vlscr.net' || hostname.endsWith('.vlscr.net');
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

const DOMAIN_ATTR = isVlscrDomain ? '; domain=.vlscr.net' : '';
const SECURE_ATTR = isLocalhost ? '' : '; secure';
const MAX_AGE = 60 * 60 * 24 * 7; // 7 días

const cookieStorage = {
  getItem(key) {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + encodeURIComponent(key).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  },
  setItem(key, value) {
    if (typeof document === 'undefined') return;
    document.cookie =
      encodeURIComponent(key) +
      '=' +
      encodeURIComponent(value) +
      `; path=/; max-age=${MAX_AGE}; samesite=lax` +
      DOMAIN_ATTR +
      SECURE_ATTR;
  },
  removeItem(key) {
    if (typeof document === 'undefined') return;
    document.cookie =
      encodeURIComponent(key) +
      '=; path=/; max-age=0; samesite=lax' +
      DOMAIN_ATTR +
      SECURE_ATTR;
  },
};

export default cookieStorage;
